import { useCallback, useEffect, useRef } from "react";
import Icon from "domains/ui/components/Icon";
import ScenarioInput from "domains/ui/components/ScenarioInput";

export interface FmHeaderSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export default function FmHeaderSearch({
  value,
  onChange,
}: FmHeaderSearchProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const changeTimeoutRef = useRef<NodeJS.Timeout | undefined>();

  // avoid latency while typing
  const handleChange = useCallback(
    (value: string) => {
      if (changeTimeoutRef.current) {
        clearTimeout(changeTimeoutRef.current);
      }

      changeTimeoutRef.current = setTimeout(() => {
        onChange(value);
        changeTimeoutRef.current = undefined;
      }, 400);
    },
    [onChange]
  );

  useEffect(() => {
    function checkValue() {
      if (!inputRef.current) return;
      if (changeTimeoutRef.current !== undefined) return;
      if (inputRef.current.value !== value) {
        inputRef.current.value = value;
      }
    }
    const timeout = setTimeout(checkValue, 400);
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [value]);

  return (
    <ScenarioInput
      ref={inputRef}
      inputProps={{
        defaultValue: value,
      }}
      setValue={handleChange}
      placeholder="Search"
      leftComponent={<Icon id="Ui/Search" color="textTertiary" />}
      dataTestId="file-manager-search-input"
      containerProps={{
        w: "250px",
        flexShrink: 0,
      }}
    />
  );
}
